import {
  getGeoMappingCrud,
  getJbpProductsTreeCrud,
  getNestedIds,
  ScopeSelectKeys,
} from 'legacy/lut/components/widgets/public/partner360/composedReport'
import { mapPartnerIds } from 'legacy/lut/features/partner360/composedReport/helpers/mapPartnerIds'

import { IComposedFilterForReport, ISelectsData } from '../models/state'

export const getFilterForReport = ({
  products,
  partnersInScope,
  scopeValue,
  amplifyMembership,
  geo,
  pbms,
  specializations,
  managers,
  acknowledged,
  fYear,
  partnersType,
  isAcknowledged,
}: ISelectsData): IComposedFilterForReport => {
  return {
    FYear: fYear,
    Pbms: pbms,
    Managers: managers,
    Geo: getNestedIds({
      values: geo,
      crud: getGeoMappingCrud(),
    }),
    Specializations: specializations,
    Products: getNestedIds({
      values: products,
      crud: getJbpProductsTreeCrud(),
    }),
    Acknowledged: acknowledged,
    AmplifyMembership: amplifyMembership,
    PartnersType: partnersType,
    IsAcknowledged: isAcknowledged ? 1 : 0,
    Scope:
      scopeValue === ScopeSelectKeys.Manual || scopeValue === ScopeSelectKeys.ManualGlobal
        ? { value: ScopeSelectKeys.Manual, partnersInScope: partnersInScope.map(mapPartnerIds) }
        : { value: scopeValue },
  }
}
